import api from './api';

export async function fetchDailyQuestions({ page = 1, perPage = 20, language = 'EN' } = {}) {
  const response = await api.get('/daily-questions/list', {
    params: {
      page: Number(page) || 1,
      per_page: Number(perPage) || 20,
      language,
    },
  });

  return response?.data?.dataset?.data || {};
}

export async function fetchDailyQuestionDetail({ dailyQuestionId, language = 'EN' } = {}) {
  const response = await api.get('/daily-questions/detail', {
    params: {
      daily_question_id: Number(dailyQuestionId),
      language,
    },
  });

  return response?.data?.dataset?.data || {};
}

export async function fetchTodayDailyQuestion({ language = 'EN' } = {}) {
  const response = await api.get('/daily-questions/today', {
    params: { language },
  });

  return response?.data?.dataset?.data || {};
}

export async function submitTodayDailyQuestionAnswer(payload = {}) {
  const response = await api.post('/daily-questions/submit-answer', payload);

  return response?.data?.dataset?.data || {};
}
